import {
	gotConversationReceiver,
	getConversationErrorReceiver,
	updateConversationTextSizeAckUpdatedReceiver,
	updateConversationTextSizeUpdateErrorReceiver,
	gotCreateNormalReplayConversationReceiver,
	createNormalReplayConversationErrorReceiver,
	createQuickPathConversationReceiver,
	createQuickPathConversationErrorReceiver,
	createSmartReplyConversationReceiver,
	createSmartReplyConversationErrorReceiver,
	closeConversationReceiver,
	closeConversationErrorReceiver,
	updatedConversationStatusEventReceiver,
	updatedConversationColorMappingEventReceiver,
	updatedConversationTextSizeEventReceiver,
	gradeConversationScoreReceiver,
	gradeConversationScoreErrorReceiver,
	conversationEventReceiver,
	clearConversationSessionReceiver,
	clearConversationSessionErrorReceiver,
	clearedConversationSessionEventReceiver,
} from './conversation-receivers';

import {
	getConversationRepliesReceiver,
	getConversationRepliesErrorReceiver,
	sendTextConversationReceiver,
	sendTextConversationErrorReceiver,
	createConversationTagReceiver,
	createConversationTagErrorReceiver,
	createConversationFormReplyReceiver,
	createConversationFormReplyErrorReceiver,
	gotTypingConversationReplyReceiver,
	createdConversationReplyEventReceiver,
	selectConversationQAOptionReceiver,
	selectConversationQAOptionErrorReceiver,
	resetConversationSmartReplyReceiver,
	contactCSConversationReceiver,
	contactCSConversationErrorReceiver,
	createConversationQAFormReplyReceiver,
	createConversationQAFormReplyErrorReceiver,
	createConversationQAChargeFormReplyReceiver,
	createConversationQAChargeFormReplyErrorReceiver,
	updatedConversationReplyEventReceiver,
} from './conversation-reply-receivers';

import {
	forceConnectSocketReceiver,
	forceDisconnectSocketReceiver,
} from './application-receiver';

import {
	updatedServiceSettingEventReceiver,
} from './service-setting-receiver';

import {
	updatedPlatformStatusEventReceiver,
	updatedPlatformSettingMaintenanceEventReceiver,
} from './platform-setting-receiver';

export default [
	// Conversation
	gotConversationReceiver,
	getConversationErrorReceiver,
	updateConversationTextSizeAckUpdatedReceiver,
	updateConversationTextSizeUpdateErrorReceiver,
	gotCreateNormalReplayConversationReceiver,
	createNormalReplayConversationErrorReceiver,
	createQuickPathConversationReceiver,
	createQuickPathConversationErrorReceiver,
	createSmartReplyConversationReceiver,
	createSmartReplyConversationErrorReceiver,
	closeConversationReceiver,
	closeConversationErrorReceiver,
	updatedConversationStatusEventReceiver,
	updatedConversationColorMappingEventReceiver,
	updatedConversationTextSizeEventReceiver,
	gradeConversationScoreReceiver,
	gradeConversationScoreErrorReceiver,
	conversationEventReceiver,
	clearConversationSessionReceiver,
	clearConversationSessionErrorReceiver,
	clearedConversationSessionEventReceiver,
	// Conversation Reply
	getConversationRepliesReceiver,
	getConversationRepliesErrorReceiver,
	sendTextConversationReceiver,
	sendTextConversationErrorReceiver,
	createConversationTagReceiver,
	createConversationTagErrorReceiver,
	createConversationFormReplyReceiver,
	createConversationFormReplyErrorReceiver,
	gotTypingConversationReplyReceiver,
	createdConversationReplyEventReceiver,
	selectConversationQAOptionReceiver,
	selectConversationQAOptionErrorReceiver,
	resetConversationSmartReplyReceiver,
	contactCSConversationReceiver,
	contactCSConversationErrorReceiver,
	createConversationQAFormReplyReceiver,
	createConversationQAFormReplyErrorReceiver,
	createConversationQAChargeFormReplyReceiver,
	createConversationQAChargeFormReplyErrorReceiver,
	updatedConversationReplyEventReceiver,
	// Applications
	forceConnectSocketReceiver,
	forceDisconnectSocketReceiver,
	// Service Setting
	updatedServiceSettingEventReceiver,
	// Platform Setting
	updatedPlatformStatusEventReceiver,
	updatedPlatformSettingMaintenanceEventReceiver,
];
